  <template>
    <center>
    <div class="">
      <div class="card card-body agatrs-card-style">
        <div class="col-md-12">
        <div class="row justify-content-md-center">
          <div class="col-md-4 ">
      <Header pageTitle="Order Modification" class="card-container"></Header>
      </div>
        </div>
      </div>
        <div class="d-flex justify-content-md-center">
          <div class="col-md-4">
            <label for="orderId">Enter Requisition or Order ID</label>
            <base-input
              id="orderId"
              v-model="selectedOrderId"
              name="Name"
              placeholder=""
            ></base-input>
            <base-button type="primary"  @click="searchOrder(selectedOrderId)" size="default">
                  Search
              </base-button>
            </div>
          </div>
          <div class="col-md-2">
            <label></label>
            <div>
            
          </div>
        </div>
        <hr/>
        <div class="">
      
      <pre-order-detail-super-admin
          :is-read-only="false"
          ref="PreOrderDetailSuperAdmin"
          v-bind:selectedOrderId="this.selectedOrderId"
        ></pre-order-detail-super-admin>
      </div>
      </div>
    </div>
  </center>
  </template>
  
  <script>
  import Util from "@/util/util";
  import Header from "@/components/App/Header";
  import { BasePagination } from "@/components";
  import { Option, Select } from "element-ui";
  import { mapGetters, mapActions } from "vuex";
  import { Table, TableColumn } from "element-ui";
  import BaseButton from '../../components/BaseButton.vue';
  import PreOrderDetailSuperAdmin from "@/components/App/order/submission/PreOrderDetailSuperAdmin.vue";

  export default {
    name: "SuperUserAdminOrder",
    components: {
      Header,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Option.name]: Option,
      [Select.name]: Select,
      BasePagination,
      BaseButton,
      PreOrderDetailSuperAdmin
    },
    data() {
      return {
        preOrder: undefined,
        selectedOrderId: undefined
      }
    },
    props: {
      // selectedOrderId: {
      //   type: String
      // }
    },
    watch: {
      
    },
    loaded() {
      this.getLssTypes();
      this.getJointStaffOrganizations();
      this.getPaymentMethods();
    },
    computed: {
      ...mapGetters({
        lssTypes: "lsstype/allLssTypes",
        paymentMethods: "paymentmethod/paymentMethods",
        orderMetadata: "orderMetadata/orderMetadata"
      }),
      isLoaded() {
        if(this.preOrder !== undefined && this.preOrder.orderId !== 0) {
          return true;
        } else {
          return false;
        }
      }
     
    },
    methods: {
      ...mapActions({
        getLssTypes: "lsstype/getLssTypes",
        getPreOrder: "preOrderDetail/getPreOrder",
        getOrderByStatus: "orders/getOrderByStatus",
        getPaymentMethods: "paymentmethod/getPaymentMethods",
        savePreOrder: "preOrderDetail/savePreOrder",
        getPreOrderStatus: "preOrderDetail/getPreOrderStatus",
        getOrderMetadata: "orderMetadata/getOrderMetadata",
      }),
      async searchOrder(val) {
        await this.$refs.PreOrderDetailSuperAdmin.searchOrder();
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
    .agatrs-card-style .custom {
      padding-left: 30% !important;
      padding-right: 30% !important;
    }
    .orderBtn {
      display: flex;
      justify-content: center;
    }

        .custom {
          margin: 0px;
        }
      
    
  </style>
  